import { render, staticRenderFns } from "./EditCard.vue?vue&type=template&id=320437b3&scoped=true&"
import script from "./EditCard.vue?vue&type=script&lang=js&"
export * from "./EditCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320437b3",
  null
  
)

export default component.exports